import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";

export class RecapitoVO {
  idSoggetto: string;
  denominazioneSoggetto: string;
  tipoSoggetto: string;
  idRecapito: string;
  denominazioneRecapito: string;
  tipo: TipoRecapitoAnagrafeEnum;
  tipoRecapito: TipoDestinatarioEnum;
  stato: string;
}
